/* global Promise */
import angular from 'angular';
import * as R from 'ramda';

export default function BulkApproveProcessesDialogController(
  $rootScope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  praDataService
) {
  const vm = this;

  vm.hasData = false;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkApprove = _handleBulkApprove;

  vm.handleSelectProcessChange = _handleSelectProcessChange;
  vm.handleSelectAll = _handleSelectAll;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    if (vm.processes.length > 0) {
      vm.hasData = true;
    }
    
    loaderService.showViewLoader = false;
  }

  function _handleCloseDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.bulkApproveProcessesDialog);
  }

  function _handleSelectProcessChange() {
    const selectedIds = [];

    R.forEach((item) => {
      if (item.isSelected === true) {
        selectedIds.push(item.processId);
      }
    }, vm.processes);

    vm.approveIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.processes.length;
  }
  
  function _handleSelectAll() {
    R.forEach((item) => {
      item.isSelected = vm.selectAll;
    }, vm.processes);
      
    vm.approveIsSelected = vm.selectAll;
  } 

  function _handleBulkApprove() {
    loaderService.showViewLoader = true;
    const bulkApproveProcessIds = [];

    // Find selections
    angular.forEach(vm.processes, (process) => {
      if (process && process.isSelected) {
        bulkApproveProcessIds.push(process.assessmentProcessId);
      }
    });

    // Stop if no selections
    if (bulkApproveProcessIds.length <= 0) {
      vm.isSelected = false;
      loaderService.showViewLoader = false;
      return Promise.resolve();
    }

    // Approve selected
    return praDataService.bulkApproveAssessmentProcesses(vm.assessmentId, bulkApproveProcessIds).then(() => {
      alerts.success('The Processes have been Approved successfully.');
      _handleCloseDialog();
      loaderService.showViewLoader = false;
      $rootScope.$broadcast('refreshPRAAssessments');
    },
    () => {
      alerts.error('There was an error while attempting to Approve the Processes.');
      loaderService.showViewLoader = false;
    });
  }
}

BulkApproveProcessesDialogController.$inject = [
  '$rootScope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'praDataService'
];
